import { isMessageDeleted, PServed } from '@wui/im'
import { nextTick, Ref } from 'vue'

import { useChatMessageStore, useDraftMessageStore } from '@/entities/messages'

import { placeCaretAtEnd } from '@/shared/utils/contenteditable-selection'

export const useStartQuote = (pServed: PServed, selectedMessageText: Ref<string>) => {
  const onStartQuote = (eventId?: number) => {
    if (eventId) {
      const event = useChatMessageStore().findById(eventId)
      if ((event?.item.type === 'OutgoingMessageEvent' || event?.item.type === 'IncomingMessageEvent') && !isMessageDeleted(event)) {
        useDraftMessageStore().setDraftQuote(pServed, eventId, selectedMessageText.value)
      }
    }

    // If input already has text, keep caret at end; empty → ChatFooter focuses + opens mobile keyboard.
    void nextTick(() => {
      const contenteditable: HTMLElement | null = document.getElementById('contenteditable')
      if (contenteditable && contenteditable.textContent?.trim()) {
        placeCaretAtEnd(contenteditable)
      }
    })
  }

  return {
    onStartQuote,
  }
}
